export default "__VITE_ASSET__Bu4xeJ9k__"